import React, { useEffect, useRef, useState ,useMemo} from 'react';
import moment from 'moment';
import './invoice.scss';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import securityService from '../security/security.service';
import saleInvoiceService from '../sale-invoice/sale-invoice.service';
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import AddNewDialog from '../software-dynamic-version-7/addNew-popup-list-v-7';
import ExcelImportDialog from './ExcelImportDialog';
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Page,
  Sort,
  Resize,
  Selection,
  Edit,
  Toolbar,
  Inject
} from "@syncfusion/ej2-react-grids";
import hardDeleteService from '../../services/hard-delete.service'

import { AutoComplete } from "@syncfusion/ej2-dropdowns";

import {
  StructuredGenerate,
  DynamicDropDownInput,
  DynamicNumericInput,
  DynamicDateInput,
  DynamicTextInput,
  DynamicHiddenInput
} from '../software-dynamic-version-5/mainSection-multiple-inputs-v-5';

import invoiceService from './invoice.service';
import dropdownService from '../software-dynamic-version-5/api.service-v-5'; // optional if you want to re-use dropdownApi

const InvoiceAdd = (props) => {
  let {
    DynamicDropDownInput: DropdownComponent,
    DynamicNumericInput: NumberComponent,
    DynamicDateInput: DateComponent,
    DynamicTextInput: TextComponent,
    DynamicHiddenInput: HiddenComponent
  } = { DynamicDropDownInput, DynamicNumericInput, DynamicDateInput, DynamicTextInput, DynamicHiddenInput };

  const updateMainSecionsValue = (valueObj) => {
    setInputProps((prevValues) => {
      const updatedValues = { ...prevValues };
      Object.keys(valueObj).forEach((key) => {
        if (updatedValues[key]) {
          updatedValues[key] = { ...updatedValues[key], ...valueObj[key] };
        }
      });
      return updatedValues;
    });
  };
const [excelDialogVisible, setExcelDialogVisible] = useState(false);
  const [inputProps, setInputProps] = useState({
    MainInvoiceID: { name: 'MainInvoiceID', value: props.MainInvoiceID || undefined },
    InvoiceType: { name: 'InvoiceType', value: props.InvoiceType || 'SS' },

    InvoiceID: { name: 'InvoiceID', value: props.InvoiceID || undefined, caption: 'Invoice No.' },
    InvoiceDate: { name: 'InvoiceDate', value: props.InvoiceDate || 'currentDate', caption: 'Invoice Date' },

    buyerBusinessName: {
      name: { id: 'BuyerNTNCNIC', value: 'buyerBusinessName' },
      caption: 'Buyer',
      value: {
        id: props.BuyerNTNCNIC || null,
        value: props.buyerBusinessName || ''
      },
      // Option A (recommended): use your own endpoint (Invoice/BuyerDDSource) by switching to "Data" later
      // Option B: if your DynamicDropDownInput is wired to dropdownApi, use a type key here instead
      dataSource: { type: 'Route', route: `InvoiceBuyerDDSource${props.InvoiceType}` }
    },

    InvoiceReferenceNo: { name: 'InvoiceReferenceNo', value: props.InvoiceReferenceNo || '-', caption: 'Reference No.' },
    DueDate: { name: 'DueDate', value: props.DueDate || 'currentDate', caption: 'Due Date' },
    Remarks: { name: 'Remarks', value: props.Remarks || '-', caption: 'Remarks' }
  });

  const [detailDS, setDetailDS] = useState([]);
  const [deleteTask, setDeleteTask] = useState({ 
    visible: false, 
    row: null,
    mode: null /*"confirm" or "success"*/ });
    const [storePreviousRowData, setStorePreviousRowData] = useState({});
  const grid = useRef(null);


const focusAndSelect = (id) => {
  requestAnimationFrame(() => {
    const el = document.getElementById(id);
    if (!el) return;

    el.focus();
    if (typeof el.select === 'function') {
      el.select();
    }
  });
};

  useEffect(() => {
    focusAndSelect('InvoiceDate');
    updateDetailsToParent([])
    if (props.isAdd === false && props.MainInvoiceID) {
      loadInvoiceDetail(props.MainInvoiceID);
    } else {
      // For add → set next invoice id
      getNextInvoiceID(props.InvoiceType || inputProps.InvoiceType.value || 'SS');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadInvoiceDetail = async (MainInvoiceID) => {
    // let FromDate = await securityService.OpeningDate()
    let FromDate = '01-JAN-25'
        const data = { InvoiceType: props.InvoiceType || 'SS',
               Type:'Detail',
         MainInvoiceID:props.MainInvoiceID || 0,
         FromDate:moment(FromDate).format('DD-MMM-YY'),
         ToDate:moment().format('DD-MMM-YY'),
         BuyerNTNCNIC:'',
         hS_CODE:'',
         InvoiceDetailID:0,
        };
    const resp = await invoiceService.getInvoiceDetail(data);
    const rows = resp?.data?.recordset || [];
    setDetailDS(rows);
  };

  const getNextInvoiceID = async (invoiceType) => {
    try {
      const resp = await invoiceService.getNextInvoiceID(invoiceType);
      const nextId = resp?.data?.recordset?.[0]?.NextInvoiceID || 1;
      updateMainSecionsValue({ InvoiceID: { value: nextId } });
    } catch (e) {
      console.log(e);
    }
  };

  const handleInputCreated = async (e, name) => {
    if (name === 'InvoiceDate' && props.isAdd === true) {
      await getNextInvoiceID(props.InvoiceType || inputProps.InvoiceType.value || 'SS');
    }
  };
const handleInputBlur = async  (value, name) => {
    // console.log(value);
    // console.log(`Input ${name} focus to ${value}`);
    if(name == 'Remarks' && props.isAdd == true){
      setTimeout(() => {
      grid.current.addRecord();
    }, 600);
    }
  };
  const updateDetailsToParent = (rows) => {
    // Only send NEW rows (no InvoiceDetailID) to list component for bulk insert
    const onlyNew = (rows || []).filter((r) => !r.InvoiceDetailID);
    if (props.getDetails) props.getDetails(onlyNew);
  };

  // ==================== Grid dropdown editor (AutoComplete) ====================
  const handleInputFocused = (inputRef, isGrid) => {
    if (isGrid) {
      if (inputRef) inputRef.showPopup();
    } else {
      if (inputRef) inputRef.current.showPopup();
    }
  };

  // const getDataSource = async (routeKey, obj) => {
  //   // Option 1: use invoice endpoints (uncomment if you prefer)
    
  //   // if (routeKey === "HSCodeDDSource") { const r = await invoiceService.getHSCodeDDSource(); obj.dataSource = r.data.recordset; return; }
  //   // if (routeKey === "UnitOfMeasurementDDSource") { const r = await invoiceService.getUnitOfMeasurementDDSource(); obj.dataSource = r.data.recordset; return; }
    
  //   // Option 2 (default here): use your existing dropdownApi service
  //   const response = await dropdownService.getAllForList(routeKey);
  //   obj.dataSource = response?.data?.recordset || [];
  // };

  const getDataSource = async (routeKey, obj) => {
    try {
      switch (routeKey) {
        // case "HSCodeDDSource": {
        //   const companyID = securityService.getCompanyIDLoggedInUserId();
        //   const hsRes = await saleInvoiceService.getItemDescCode(companyID);
        //   obj.dataSource = (hsRes?.data || []).map(r => ({
        //     id: r.hS_CODE,
        //     value: `${r.hS_CODE} | ${r.description}`
        //   }));
        //   break;
        // }
        
        // case "ItemDescriptionSource": { // Example for future
        //   const companyID = securityService.getCompanyIDLoggedInUserId();
        //   const res = await saleInvoiceService.getItems(companyID);
        //   obj.dataSource = (res?.data || []).map(r => ({
        //     value: r.itemCode,
        //     text: r.itemName
        //   }));
        //   break;
        // }
        
        default:
          // Default dropdown service
          const response = await dropdownService.getAllForList(routeKey);
          obj.dataSource = response?.data?.recordset || [];
      }
    } catch (error) {
      console.error(`Error loading ${routeKey}:`, error);
      obj.dataSource = [];
    }
  };

  const autoCompleteInstances = {};

  const createAutoComplete = (params) => {
    let obj : AutoComplete;
      let elem : HTMLElement;

    const create = () => {
      elem = document.createElement("input");
      return elem;
    };
    const destroy = () => obj?.destroy();
    const read = () => obj?.text;

    const write = async (args) => {
      const dynamicKey = `obj_${params.field.id}`;

      autoCompleteInstances[dynamicKey]  = new AutoComplete({
        value: args.rowData[params.field.value],
        fields: { value: "value"},
        placeholder: `Select ${params.caption}`,
        highlight: true,
        showClearButton: false,

        created: async (arg) => {
          console.log(args)
          console.log(arg)
          if (params?.source?.type === "Route") {
            await getDataSource(params.source.dataSource,  autoCompleteInstances[dynamicKey] );
          } else if (params?.source?.type === "Data") {
            autoCompleteInstances[dynamicKey].dataSource = params?.source?.dataSource || [];
          }
        if(args.requestType == 'beginEdit'){
          autoCompleteInstances[dynamicKey].dropdownValues =  { id:args.rowData[params.field.id],  value: args.rowData[params.field.value],...args.rowData}
        }
          if (params.onCreated) {
            params.onCreated(
              {
                ...args.rowData,
                id: args.rowData[params.field.id],
                value: args.rowData[params.field.value],
              },
              params.field.value,
              args,
              autoCompleteInstances
            );
          }
        },

        focus: () => handleInputFocused( autoCompleteInstances[dynamicKey] , true),

        select: async (e) => {
          // assign id + value fields
          console.log(e)
          // autoCompleteInstances[dynamicKey].itemData =  { ...e.itemData, id: e.itemData?.id, value: e.itemData?.value };
          autoCompleteInstances[dynamicKey].dropdownValues =  { id: e.itemData?.id ,  value: e.itemData?.value,...e.itemData}
          if (params.field.id) args.rowData[params.field.id] = e.itemData.id;
          args.rowData[params.field.value] = e.itemData.value;

          if (params.onSelect) {
            params.onSelect(
              { ...e.itemData, id: e.itemData?.id, value: e.itemData?.value },
              params.field.value,
              args,
              autoCompleteInstances
            );
          }
        },

        change: (e) => {
          console.log(e)
          // autoCompleteInstances[dynamicKey].itemData =  { ...e.itemData, id: e.itemData?.id, value: e.itemData?.value };
          autoCompleteInstances[dynamicKey].dropdownValues =  { id: e?.itemData?.id ,  value: e?.itemData?.value,...e.itemData}
          const ds = Array.isArray( autoCompleteInstances[dynamicKey] .dataSource) ?  autoCompleteInstances[dynamicKey] .dataSource : [];
          const isValid = ds.some((s) => s.value === e.value);
          if (!isValid) {
            if (params.field.id) args.rowData[params.field.id] = undefined;
            args.rowData[params.field.value] = e?.value;
          } else {
            const selectedItem = ds.find((s) => s.value === e.value);
            if (params.field.id) args.rowData[params.field.id] = selectedItem.id;
            args.rowData[params.field.value] = selectedItem.value;
          }
        }
      });

      autoCompleteInstances[dynamicKey] .appendTo(elem);
      // autoCompleteInstances[dynamicKey] = obj;
    };

    return { create, destroy, read, write };
  };


  

// Delete Section Start

// OK in confirm dialog → do deletion, reindex, then show success
const handleConfirmOk = async () => {
    console.log(deleteTask
    )
    const row = deleteTask.row;
    if (!row) {
      // Ensure we have a row; if not, just close
      setDeleteTask({ visible: false, mode: null, row: null });
      return;
    }

    try {
      if (row.InvoiceDetailID) {
        // Backend delete
           const data = {
    TableName: 'InvoiceDetail',
    ColumnName: 'InvoiceDetailID', // Use corresponding column name or first
    RowID: row.InvoiceDetailID, // Use corresponding row ID or first

        }
        await hardDeleteService.hardDelete(data)
        
        const newData = detailDS.filter(r => r.InvoiceDetailID !== row.InvoiceDetailID);
        newData.forEach((r, idx) => { r.IndexID = idx + 1; });
        setDetailDS(newData);
        updateDetailsToParent(newData)
        setDeleteTask({ visible: true, mode: "success", row: null });
      } else {
        // Local delete
        const newData = detailDS.filter(r => r.IndexID !== row.IndexID);
        newData.forEach((r, idx) => { r.IndexID = idx + 1; });
        updateDetailsToParent(newData)
        setDetailDS(newData);
        setDeleteTask({ visible: true, mode: "success", row: null });
      }

      // Switch to success dialog
    } catch (err) {
      // Optional: handle errors
      console.error("Delete failed:", err);
      setDeleteTask({ visible: false, mode: null, row: null });
    }
  }
  
  const closedeleteDialog = () => {
    setDeleteTask({ visible: false, mode: null, row: null });
  };
  // Delete Section END

  // ==================== Grid config ====================
  const gridConfig = {
    height: "260",
    width: "100%",
    rowHeight: 25,
    gridLines: "Horizontal",
    
  allowTextWrap: true,
  textWrapSettings: { wrapMode: "Both" },// Content,Header,Both
  
  clipMode:"Clip" ,// EllipsisWithTooltip, Ellipsis ,Clip
    
    allowPaging: true,
    allowSorting: true,
    allowResizing: true,
    allowSelection: true,
    allowFiltering: false,
    pageSettings: { pageSize: 10, pageSizes: [5, 10, 20, 50, 100, 'All'] },
    selectionSettings: { type: "Single", mode: "Row" },
    editSettings: {
      allowAdding: true,
      allowEditing: true,
      allowDeleting: true,
      mode: "Normal",
      showDeleteConfirmDialog: false,
      newRowPosition: "Top"
    },
    toolbar: ["Add", "Edit", "Delete", "Update", "Cancel"],
      /* ================= AGGREGATES ================= */
aggregates:[
  // Block 1: Page Sum
  // {
  //   columns: [
  //     {
  //       type: 'Sum',
  //       field: 'qty',
  //       footerTemplate: () => (
  //         <span style={{ fontWeight: 'bold', color: '#0078D4' }}>
  //           Page Sum: {gridRef.current?.getCurrentViewRecords().reduce((acc, r) => acc + r.qty, 0)}
  //         </span>
  //       )
  //     }
  //   ]
  // },
  // Block 2: Group Sum (Page)
  // {
  //   columns: [
  //     {
  //       type: 'Sum',
  //       field: 'qty',
  //       groupFooterTemplate: (props) => (
  //         <span style={{ fontStyle: 'italic', color: '#444' }}>
  //           Group Sum (Page): {props.Sum}
  //         </span>
  //       )
  //     }
  //   ]
  // },
  // Block 3: Dataset Sum
  {
    columns: [
      {
        type: 'Sum',
        field: 'Quantity',
        format:'n2',
        footerTemplate: (props) => (
          <span style={{ fontWeight: 'bold', color: '#28A745' }}>
             Sum: {props.Sum}
          </span>
        )
      },
      {
        type: 'Sum',
        field: 'FBRQuantity',
        format:'n2',
        footerTemplate: (props) => (
          <span style={{ fontWeight: 'bold', color: '#28A745' }}>
             Sum: {props.Sum}
          </span>
        )
      },
      {
        type: 'Sum',
        field: 'BillAmount',
        format:'n2',
        footerTemplate: (props) => (
          <span style={{ fontWeight: 'bold', color: '#28A745' }}>
             Sum: {props.Sum}
          </span>
        )
      },
      {
        type: 'Sum',
        field: 'TaxAmount',
        format:'n2',
        footerTemplate: (props) => (
          <span style={{ fontWeight: 'bold', color: '#28A745' }}>
             Sum: {props.Sum}
          </span>
        )
      },
      {
        type: 'Sum',
        field: 'TotalAmount',
        format:'n2',
        footerTemplate: (props) => (
          <span style={{ fontWeight: 'bold', color: '#28A745' }}>
             Sum: {props.Sum}
          </span>
        )
      }
    ]
  }
],

  };

 



  const toNum = (v) => {
  const n = parseFloat((v ?? "0").toString().replace(/,/g, ""));
  return isNaN(n) ? 0 : n;
};

// let  = {}

const actionComplete = async (args) => {

  /* ================= BEGIN EDIT / ADD ================= */
  if (args.requestType === 'beginEdit' || args.requestType === 'add') {

    const calc = () => {
      const qty     = toNum(document.getElementById('InvoiceDetailQuantity')?.value);
      const rate    = toNum(document.getElementById('InvoiceDetailRate')?.value);
      const taxPer  = toNum(document.getElementById('InvoiceDetailTaxPercent')?.value);

      const bill    = qty * rate;
      const taxAmt  = bill * (taxPer / 100);
      const total   = bill + taxAmt;

      if (args.form.elements["InvoiceDetailBillAmount"])
        args.form.elements["InvoiceDetailBillAmount"].ej2_instances[0].value = bill;

      if (args.form.elements["InvoiceDetailTaxAmount"])
        args.form.elements["InvoiceDetailTaxAmount"].ej2_instances[0].value = taxAmt;

      if (args.form.elements["InvoiceDetailTotalAmount"])
        args.form.elements["InvoiceDetailTotalAmount"].ej2_instances[0].value = total;
    };

    // attach runtime calculation
    ["Quantity", "Rate", "TaxPercent"].forEach((f) => {
      const el = document.getElementById(`InvoiceDetail${f}`);
      if (el) {
        el.addEventListener("input", calc);
        el.addEventListener("keyup", calc);
        el.addEventListener("keydown", calc);
      }
    });

   

    // tab behavior (same UX as voucher)
    document
      .getElementById('InvoiceDetailTotalAmount')
      ?.addEventListener('keydown', (e) => {
        e.stopPropagation();
        if (e.key === 'Tab') {
          setTimeout(() => grid.current.endEdit(), 200);
        }
      });
  }

  /* ================= SAVE ================= */
  // if(args.requestType == 'save' && args.action == 'add'){
  //   setStorePreviousRowData({
  //       Quantity:args.data.Quantity || 0,
  //     FBRQuantity:args.data.FBRQuantity || 0,
  //     Rate:args.data.Rate || 0,
  //     BillAmount:args.data.BillAmount || 0,
  //     TaxPercent:args.data.TaxPercent || 0,
  //     TaxAmount:args.data.TaxAmount || 0,
  //     TotalAmount:args.data.TotalAmount || 0,
  //     ProductDescription:args.data.ProductDescription || '-'
  //   })
  //   console.log(storePreviousRowData)
  // }
  if (args.requestType === 'save') {

    
console.log(autoCompleteInstances)
    let copyData = [...grid.current.dataSource];
    const targetIndex = args.action === 'add' ? 0 : args.rowIndex;
    console.log(copyData)
    console.log(args.data)
    copyData[targetIndex] = {
      ...copyData[targetIndex],
      ...args.data,

      IndexID: args.action === 'add'
        ? copyData.length
        : args.data.IndexID,

      Quantity:args.data.Quantity || 0,
      FBRQuantity:args.data.FBRQuantity || 0,
      Rate:args.data.Rate || 0,
      BillAmount:args.data.BillAmount || 0,
      TaxPercent:args.data.TaxPercent || 0,
      TaxAmount:args.data.TaxAmount || 0,
      TotalAmount:args.data.TotalAmount || 0,
      hS_CODE:autoCompleteInstances['obj_hS_CODE'].dropdownValues.id,
      FBRUnitOfMeasurementID:autoCompleteInstances['obj_FBRUnitOfMeasurementID'].dropdownValues.id,
      UnitOfMeasurementID:autoCompleteInstances['obj_UnitOfMeasurementID'].dropdownValues.id,
      ProductDescription: args.data.ProductDescription || "-",
      DescriptionCode:autoCompleteInstances['obj_hS_CODE'].dropdownValues.value,
      FBRUnitOfMeasurement:autoCompleteInstances['obj_FBRUnitOfMeasurementID'].dropdownValues.value,
      UnitOfMeasurement:autoCompleteInstances['obj_UnitOfMeasurementID'].dropdownValues.value,
      // UnitOfMeasurementID: args.data.UnitOfMeasurementID || 1
    };

    setDetailDS(copyData);
    updateDetailsToParent(copyData);

    // DB update only for existing rows
    if (args.action === 'edit' && args.data.InvoiceDetailID) {
      await invoiceService.updateDetailData(copyData[targetIndex]);
    }

    // auto move to next row (voucher style)
    if(args.action == 'edit'){
    const gridLength = grid.current.currentViewData.length;
    setTimeout(() => {
      const nextRow = args.rowIndex + 1;
      if (nextRow < gridLength) {
        grid.current.selectRow(nextRow);
        grid.current.startEdit();
      }
    }, 600);
  }else{
    setTimeout(() => {
      grid.current.addRecord();
    }, 600);
  }

  }
};


  // Default values on add row
  const actionBegin = (args) => {

    console.log(args)
    if (args.requestType === 'add') {
      console.log(storePreviousRowData)
      args.data.ProductDescription = '-';
      args.data.Quantity =  0;
      args.data.FBRQuantity =  0;
      args.data.Rate =  0;
      args.data.BillAmount =  0;
      args.data.TaxPercent =  18;
      args.data.TaxAmount =  0;
      args.data.TotalAmount =  0;

      // args.data.ProductDescription = storePreviousRowData.ProductDescription || '-';
      // args.data.Quantity = storePreviousRowData.Quantity || 0;
      // args.data.FBRQuantity = storePreviousRowData.FBRQuantity || 0;
      // args.data.Rate = storePreviousRowData.Rate || 0;
      // args.data.BillAmount = storePreviousRowData.BillAmount || 0;
      // args.data.TaxPercent = storePreviousRowData.TaxPercent || 18;
      // args.data.TaxAmount = storePreviousRowData.TaxAmount || 0;
      // args.data.TotalAmount = storePreviousRowData.TotalAmount || 0;
      args.data.UnitOfMeasurementID = 1;
      args.data.description = '';
      args.data.FBRUnitOfMeasurementID = '';
      args.data.FBRUnitOfMeasurement = '';
      args.data.UnitOfMeasurement = '';
      args.data.hS_CODE = '';
      args.data.DescriptionCode = '';
    }
    if (args.requestType === "delete") { args.cancel = true; // stop default delete 
 const row = Array.isArray(args.data) ? args.data[0] : args.data; 
setDeleteTask({ visible: true, mode: "confirm", row });

}
  };

  // ==================== Main Inputs ====================
  const inputsList = [
    { Input: HiddenComponent, Props: { ...inputProps.MainInvoiceID, setInputProps }, ColumnSize: 0 },
    { Input: HiddenComponent, Props: { ...inputProps.InvoiceType, setInputProps }, ColumnSize: 0 },

    { Input: TextComponent, Props: { ...inputProps.InvoiceID, setInputProps, enabled: false }, ColumnSize: 3 },
    { Input: DateComponent, Props: { ...inputProps.InvoiceDate, setInputProps, onCreated: handleInputCreated }, ColumnSize: 3 },
    { Input: DropdownComponent, Props: { ...inputProps.buyerBusinessName, setInputProps }, ColumnSize: 6 },

    { Input: TextComponent, Props: { ...inputProps.InvoiceReferenceNo, setInputProps }, ColumnSize: 4 },
    { Input: DateComponent, Props: { ...inputProps.DueDate, setInputProps }, ColumnSize: 4 },
    // { Input: TextComponent, Props: { ...inputProps.Remarks, setInputProps ,onBlur:handleInputBlur}, ColumnSize: 12 }
    { Input: TextComponent, Props: { ...inputProps.Remarks, setInputProps, onBlur: handleInputBlur }, ColumnSize: 9 },
{
  Input: () => (
    <div style={{ display: 'flex', alignItems: 'flex-end',  }}>
      <button
        type="button"
        onClick={() => setExcelDialogVisible(true)}
        style={{
          // width: '100%',
          padding: '8px',
          background: '#009f60',
          color: '#fff',
          border: 'none',
          borderRadius: 1,
          fontWeight: 700,
          fontSize: 13,
          cursor: 'pointer',
          textTransform:'uppercase'
          // gap: 6,
          // whiteSpace: 'nowrap',
          // boxShadow: '0 2px 8px rgba(230,81,0,0.30)'
        }}
      >
        Fill Data
      </button>
    </div>
  ),
  Props: {name:'FillDataButton'},
  ColumnSize: 3
}
  ];
  const handleExcelDataLoaded = (importedRows) => {
  // Assign sequential IndexID continuing from current grid data
  const startIndex = detailDS.length;
  const indexedRows = importedRows.map((row, i) => ({
    ...row,
    IndexID: startIndex + i + 1
  }));
  const newDetailDS = [...detailDS, ...indexedRows];
  setDetailDS(newDetailDS);
  updateDetailsToParent(newDetailDS);
};
  
  // const rowDataBound = (args) => {
  //   if (args?.data?.isDuplicateProductDescription) {
  //     args.row.classList.add("dup-text-red");
  //     args.row.title = "Duplicate Product Description";
  //   }
  // };
  

  const rowDataBound = (args) => {
    if (args?.data?.isDuplicateProductDescription) {
      args.row.classList.add("dup-text-red");
      args.row.title = "Duplicate Product Description";
      const tooltip = new TooltipComponent({
        content: "Duplicate Product Description",
        opensOn: "Hover",
        position: "TopCenter",
        showTipPointer: true,
        cssClass: "dup-tooltip",   // 🔑 IMPORTANT

        mouseTrail: false,
        animation: {
          open: { effect: "FadeIn", duration: 150 },
          close: { effect: "FadeOut", duration: 100 },
        },
        openDelay: 40,   // ⏱ REAL delay
        closeDelay: 50,
      });
  
      tooltip.appendTo(args.row);
    }
  };
  

  const onClosing =async (e)=>{
    if(e ==  'UnitOfMeasurement'){
      let dynamicKey = `obj_UnitOfMeasurementID`
       await getDataSource(`UnitOfMeasurementDDSource`,autoCompleteInstances[dynamicKey])
       if(document.getElementById('InvoiceDetailUnitOfMeasurement')){
        document.getElementById('InvoiceDetailUnitOfMeasurement').focus()
       }
    }
  }
    
  return (
    <div onKeyDown={(e) =>{ 
      if (e.key === 'Escape') {
        console.log('ESC pressed');
        // your logic here
        e.stopPropagation()
      }
      e.stopPropagation()
      }}>
{/* ── EXCEL IMPORT DIALOG ── */}
<ExcelImportDialog
  visible={excelDialogVisible}
  onClose={() => setExcelDialogVisible(false)}
  onDataLoaded={handleExcelDataLoaded}
/>
      <StructuredGenerate mainProps={props} title={`${props.Title} ${props.isAdd === true ? ` - Add` : ` - Edit`}`} Inputs={inputsList} />

      <br />
      <div>
        
      {/* Confirm dialog */}
      {deleteTask.visible && deleteTask.mode === "confirm" && (
        <DialogComponent visible={true} header="Confirm Delete" content="Are you sure you want to delete this record?" showCloseIcon={false} width="300px" buttons={[ { buttonModel: { content: "OK", isPrimary: true }, click: () => handleConfirmOk()
            },
            {
              buttonModel: { content: "Cancel" },
              click: () => closedeleteDialog()
            }
          ]}
        />
      )}

      {/* Success dialog */}
      {deleteTask.visible && deleteTask.mode === "success" && (
        <DialogComponent visible={true} header="Success" content="Row deleted successfully." showCloseIcon={false} width="250px" buttons={[ { buttonModel: { content: "OK", isPrimary: true }, click: () => closedeleteDialog() }
          ]}
        />
      )}
        </div>

      <GridComponent
        id={'InvoiceDetail'}
        ref={grid}
        
        dataSource={detailDS}
        {...gridConfig}
        actionBegin={actionBegin}
         actionComplete={actionComplete}
         rowDataBound={rowDataBound}     
         
          >
        <ColumnsDirective>
          <ColumnDirective field="IndexID" headerText="ID" isPrimaryKey width="80" visible={false} />
          <ColumnDirective field="InvoiceDetailID" headerText="DetailID" width="120" visible={false} />
          <ColumnDirective field="UnitOfMeasurementID" headerText="UnitID" width="80" visible={false} />
          <ColumnDirective field="FBRUnitOfMeasurementID" headerText="FBRUnitOfMeasurementID" width="80" visible={false} />
          <ColumnDirective field="hS_CODE" headerText="hS_CODE" width="80" visible={false} />

          <ColumnDirective
            field="DescriptionCode"
            headerText="HS Code"
            width="100"
            editType="dropdownedit"
            headerTextAlign="center"
            
            edit={createAutoComplete({
              field: { id: "hS_CODE", value: "DescriptionCode" },
              caption: "HS Code",
              source: { type: "Route", dataSource: "HSCodeDDSource" }
            })}
            
          />

          <ColumnDirective field="ProductDescription" headerText="Description"headerTextAlign="center" width="150" />

          <ColumnDirective  field="Quantity" headerText="Qty" textAlign="right" headerTextAlign="center"width="110" format="n2" editType="numericedit" edit={{ params: { cssClass: 'num-right',format: 'n2' } }} />
          <ColumnDirective  field="FBRQuantity" headerText="FBR Qty" textAlign="right" headerTextAlign="center"width="110" format="n2" editType="numericedit" edit={{ params: { cssClass: 'num-right',format: 'n2' } }} />
          <ColumnDirective field="Rate" headerText="Rate" textAlign="right" headerTextAlign="center"width="90" format="n2" editType="numericedit" edit={{ params: { cssClass: 'num-right',format: 'n2' } }} />

          <ColumnDirective
            field="UnitOfMeasurement"
            headerText="UOM"
            width="110"
            editType="dropdownedit"
            headerTextAlign="center"
            edit={createAutoComplete({
              field: { id: "UnitOfMeasurementID", value: "UnitOfMeasurement" },
              caption: "Unit Of Measurement",
              source: { type: "Route", dataSource: "UnitOfMeasurementDDSource" }
            })}
          />
          <ColumnDirective
            field="FBRUnitOfMeasurement"
            headerText="FBR UOM"
            width="110"
            editType="dropdownedit"
            headerTextAlign="center"
            edit={createAutoComplete({
              field: { id: "FBRUnitOfMeasurementID", value: "FBRUnitOfMeasurement" },
              caption: "FBR Unit Of Measurement",
              source: { type: "Route", dataSource: "UOMINVOICECHALLANINPUT" }
            })}
          />

          <ColumnDirective field="BillAmount"  textAlign="right" headerTextAlign="center" headerText="Bill" width="135" format="n2" editType="numericedit" edit={{ params: { cssClass: 'num-right',format: 'n2' } }} allowEditing={true} />
          <ColumnDirective field="TaxPercent"  textAlign="right" headerTextAlign="center" headerText="Tax %" width="90" format="n2" editType="numericedit" edit={{ params: { cssClass: 'num-right',format: 'n2' } }} />
          <ColumnDirective field="TaxAmount"  textAlign="right" headerTextAlign="center" headerText="Tax Amt" width="135" format="n2" editType="numericedit" edit={{ params: { cssClass: 'num-right',format: 'n2' } }} allowEditing={true} />
          <ColumnDirective  field="TotalAmount"  textAlign="right" headerTextAlign="center" headerText="Total" width="135" format="n2" editType="numericedit" edit={{ params: { cssClass: 'num-right',format: 'n2' } }} allowEditing={true} />
        </ColumnsDirective>

        <Inject services={[Page, Sort, Resize, Selection, Edit, Toolbar]} />
      </GridComponent>
      <AddNewDialog 
        Route={'UnitOfMeasurement'} 
        Security={true} 
        onClosed={onClosing} 
        RefName={'UnitOfMeasurement'}
        Caption={'ADD NEW UOM'}
        />
    </div>
  );
};

export default InvoiceAdd;
